import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Ticket } from "../../../model/ticket";
import { Labeler } from "../../../model/labeler";
import { StatusService } from "../../../services/status.service";
import { PrioritiesService } from "../../../services/priorities.service";
import { DepartmentsService } from "../../../services/departaments.service";
import { BranchService } from "../../../services/branch.service";
import { Observer } from "rxjs";
import { RecurrenceService } from "../../../services/recurrence.service";

@Component({
  selector: "ticket-row",
  templateUrl: "./ticket-row.component.html",
  styleUrls: ["./ticket-row.component.css"],
})
export class TicketRowComponent {
  @Input() ticket!: Ticket;
  @Input() isSelectedFlag = false;
  @Input() selectedTicket: Ticket | null = null;
  @Output() selectToggled = new EventEmitter<Ticket>();
  @Output() ticketClicked = new EventEmitter<Ticket>();

  constructor(
    private status: StatusService,
    private priority: PrioritiesService,
    private department: DepartmentsService,
    private branch: BranchService,
    private recurrenceService: RecurrenceService
  ) {}

  /** Of dit ticket bij een terugkeerreeks hoort. */
  get isRecurring(): boolean {
    return this.recurrenceService.isRecurring(this.ticket?.id);
  }

  get statusLabelerByService(): Labeler {
    return this.status;
  }
  get priorityLabelerByService(): Labeler {
    return this.priority;
  }
  get departmentLabelerByService(): Labeler {
    return this.department;
  }
  get branchLabelerByService(): Labeler {
    return this.branch;
  }
  get departmentIdObserver(): Partial<Observer<number>> {
    return { next: () => {} };
  }
  /** Whether a field is set: 0, "-" and nothing mean it is not. */
  isValidChoice(value: any): boolean {
    return value !== null && value !== undefined && value !== 0 && value !== "-";
  }

  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }

  dateFormatted(ticket: Ticket): string {
    const date = ticket.created;
    if (!date) return "";

    const dateParts = date.split("T");
    const parts = dateParts[0].split("-");
    const parsed = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );

    const createdYear = Number(parts[0]);
    const year = new Date().getFullYear();
    const sameYear = year === createdYear;

    return sameYear
      ? new Intl.DateTimeFormat(undefined, {
          day: "numeric",
          month: "long",
        }).format(parsed)
      : new Intl.DateTimeFormat(undefined, {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(parsed);
  }

  onSelect(event: Event): void {
    event.stopPropagation();
    this.selectToggled.emit(this.ticket);
  }

  onClick(): void {
    this.ticketClicked.emit(this.ticket);
  }
}
